import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  light?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  centered = false,
  light = false
}: SectionHeadingProps) {
  return <div className={`mb-12 ${centered ? 'text-center' : 'text-left'}`} data-id="element-127">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className={`text-3xl md:text-4xl font-bold mb-4 ${light ? 'text-white' : 'text-navy-900'}`} data-id="element-128">
        {title}
      </motion.h2>
      {subtitle && <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className={`text-lg max-w-2xl ${centered ? 'mx-auto' : ''} ${light ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-129">
          {subtitle}
        </motion.p>}
      <motion.div initial={{
      opacity: 0,
      scaleX: 0
    }} whileInView={{
      opacity: 1,
      scaleX: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className={`h-1 w-20 mt-6 ${centered ? 'mx-auto' : ''} bg-tech-green rounded-full origin-left`} data-id="element-130" />
    </div>;
}